import suiteService from 'qreventos-suite/services';
import invitacionService from 'qreventos-suite/invitaciones';

class SuiteConfig {
    evento:number = 922;
    token:string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4STNneDZuYncvaUZnVTl4cU9kQjlXaz0=';
    clientId: string = '0625f8c0-9116-4bb7-8225-562e3c6441d7-922';

    public constructor() {
      suiteService.clientId = this.clientId;
      suiteService.token = this.token;  

      invitacionService.clientId = this.clientId;
      invitacionService.token = this.token;
    }
}

export default new SuiteConfig();
